import { createAsyncThunk } from '@reduxjs/toolkit';
import { LocationManagement } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchLocationManagement,
  FindLocationManagement,
  GetLocationManagement,
} from './interface';

export const findLocationManagement = createAsyncThunk(
  'locationManagement/findLocationManagement',
  async (values: FindLocationManagement, { rejectWithValue }) => {
    try {
      const response = await LocationManagement.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createLocationManagement = createAsyncThunk(
  'locationManagement/createLocationManagement',
  async (values: CreatePatchLocationManagement, { rejectWithValue }) => {
    try {
      const response = await LocationManagement.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchLocationManagement = createAsyncThunk(
  'locationManagement/patchLocationManagement',
  async (
    { id, ...values }: CreatePatchLocationManagement,
    { rejectWithValue }
  ) => {
    try {
      const response = await LocationManagement.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getLocationManagement = createAsyncThunk(
  'locationManagement/getLocationManagement',
  async ({ id }: GetLocationManagement, { rejectWithValue }) => {
    try {
      const response = await LocationManagement.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
